import { FormControlLabel } from '@material-ui/core';
import { FormControlLabelProps } from '@material-ui/core/FormControlLabel/FormControlLabel';
import React from 'react';
import { useStyles, useStylesForCustomLabel, StyledFormWithCustomLabel } from './LabelFormControl.styles';

export interface LabelFormControlProps extends FormControlLabelProps {
  dataQaId?: string;
  /*
   * Label element allow pass label as html,
   * can be used as an alternative to the label prop.
   */
  labelElement?: React.ReactElement<any, any>;
}

const LabelFormControl: React.FC<LabelFormControlProps> = ({ labelElement, dataQaId, ...props }) => {
  const classes = useStyles();
  const classesForCustomLabel = useStylesForCustomLabel();
  if (!labelElement) {
    return <FormControlLabel classes={classes} data-qa-id={`${dataQaId}-label-form-control`} {...props} />;
  }

  return (
    <StyledFormWithCustomLabel data-qa-id={`${dataQaId}-label-form-control`} disabled={props.disabled}>
      <FormControlLabel classes={classesForCustomLabel} {...props} />
      {React.cloneElement(labelElement)}
    </StyledFormWithCustomLabel>
  );
};
export default LabelFormControl;
